import React, { useEffect } from "react";
import { styled } from '@mui/material/styles';
import Study from "./Study";
import Analyses from "./Analyses";
import { setDetails } from "../../actions/details";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { setHazard, setAnalysisType } from "../../actions/filters";
import { parseSearch } from "../../actions/helpers";

import handleGA, { gaEvents } from "../../googleAnalytics";

const PREFIX = 'Details';

const classes = {
  root: `${PREFIX}-root`
};

const Root = styled('div')((
  {
    theme
  }
) => ({

}));

const Details = ({ setDetails, setHazard, setAnalysisType, filters }) => {


  useEffect(() => {
    setDetails();
    const searchParams = parseSearch();
    const { hazard, analysisType } = searchParams;
    // SET filters
    let updateObj = {};
    if (hazard) {
      hazard.split(",").map((item) => (updateObj[item.toLowerCase()] = true));
      setHazard(updateObj);
    }
    if (analysisType) {
      let updateObj = {};
      analysisType
        .split(",")
        .map((item) => (updateObj[item.toLowerCase()] = true));
      setAnalysisType(updateObj);
    }
  }, []);

  useEffect(() => {
    // Google Analytics
    handleGA(gaEvents.PAGE_VIEW, window.location.pathname);
  }, []);

  return (
    <Root className={classes.root}
	sx={{
		marginTop: "0.4em",
	    maxWidth: "70em",
	    width: "100%",
	}}>
	      <Study />
	      <Analyses />
    </Root>
  );
};

Details.propTypes = {
  setDetails: PropTypes.func.isRequired,
  setHazard: PropTypes.func.isRequired,
  setAnalysisType: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  filters: state.filters,
});

export default connect(mapStateToProps, {
  setDetails,
  setHazard,
  setAnalysisType,
})(Details);
